<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="true"></loading>
        <!-- 과목 선택 -->
        <div class="class_box">
            <em><img :src="ConstData.IMG_PATH + '/gong/landing/2018/premium_classlist/stit_class01.png'" alt="과목 선택" /></em>
            <ul class="class_list01">
                <ul class="class_list01">
                    <li v-for="row in subjectList"
                        :key="row.store_category_id"
                        :class="row.store_category_id == subjectCategoryId ? 'active' : ''"
                        class="subjectList">
                        <a href="javascript:void(0)" @click="changeSubject(row.store_category_id)">{{row.category_name}}</a>
                    </li>
                </ul>
            </ul>
        </div>
        <!-- //과목 선택 -->
        <!-- 단과 강좌 찾아보기 -->
        <div class="class_box">
            <em><img :src="ConstData.IMG_PATH + '/gong/landing/2018/premium_classlist/stit_class02.png'" alt="단과 강좌 찾아보기" /></em>
            <div class="class_list02">
                <div class="class_select">
                    <span>년도</span>
                    <ul>
                        <li :class="year === null ? 'active' : ''"><a  href="javascript:void(0);" @click="setYear(null)">전체보기</a></li>
                        <li v-for="(row, index) in yearList[subjectCategoryId]"
                            :key="index"
                            :class="year === row ? 'active' : ''"
                            v-if="Object.prototype.hasOwnProperty.call(yearInfo, row)">
                            <a href="javascript:void(0);" @click="setYear(row)">{{yearInfo[row]}}</a></li>
                    </ul>
                </div>
                <div class="class_select">
                    <span>학습단계</span>
                    <ul>
                        <li :class="levelType === null ? 'active' : ''"><a  href="javascript:void(0);" @click="setLevelType(null)">전체보기</a></li>
                        <li v-for="(row, index) in levelTypeList[subjectCategoryId]"
                            :key="index" :class="levelType === row ? 'active' : ''"
                            v-if="Object.prototype.hasOwnProperty.call(levelInfo, row)"
                            class="levelList">
                            <a href="javascript:void(0);" @click="setLevelType(row)">{{levelInfo[row]}}</a>
                        </li>
                    </ul>
                </div>
                <div class="class_select">
                    <span>교수님 선택</span>
                    <select v-model="teacherId"
                            @change="setTeacher"
                            :value=null
                            id="teacherList" class="nomalSelect" style="width:100px;">
                        <option :value=null>전체</option>
                        <option v-for="(row, index) in teacherList[subjectCategoryId]"
                                :value="row.teacher_id"
                                :key="index">{{row.teacher_name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <!-- //단과 강좌 찾아보기 -->

        <!-- 강의 리스트 영역 -->
        <div>
            <online-lecture-list
                    :lecture-info="lectureInfo"
                    :width-css="widthCss"
                    :double-info="doubleInfo"
                    :category-id=categoryId
                    :pay-buttons=payButtons
                    :is-membership-lectures=isMembershipLectures
                    :multiple-play-popup=multiplePlayPopup>
            </online-lecture-list>
        </div>
        <!-- //강의 리스트 영역 -->
    </div>
</template>

<script>
import Axios from 'axios';
import Loading from 'vue-loading-overlay';

import OnlineLectureList from './online-lecture-list';

export default {
  props: {
    categoryId: { type: Number, default: NaN },
    isMembershipLectures: { type: Boolean, default: false },
    withSubject: { type: Boolean, default: true },
    randSubject: { type: Boolean, default: true },
    doubleInfo: { type: Boolean, default: true },
    payButtons: { type: Boolean, default: true },
    multiplePlayPopup: { type: Boolean, default: true },
    widthCss: { type: String, default: 'w960' },
    paymentSetting: { type: String, default: 'myclass.dangi.co.kr' },
  },
  name: 'online-lecture-membership',
  created() {
    if (typeof payment_setting === 'function') {
      payment_setting({ domain: this.paymentSetting });
    } else {
      console.log('결제 라이브러리 호출 실패');
    }

    Axios.get('/gong/lecture/lecture_ajax/ax_get_LectureOtherInfo').then((response) => {
      if (Object.prototype.hasOwnProperty.call(response.data, 'result') === true) {
        const nowResult = response.data.result;
        if (Object.prototype.hasOwnProperty.call(nowResult, 'levelTypeList') === true) {
          this.levelInfo = nowResult.levelTypeList;
        }
        if (Object.prototype.hasOwnProperty.call(nowResult, 'yearList') === true) {
          this.yearInfo = nowResult.yearList;
        }

        /*
        if (Object.prototype.hasOwnProperty.call(nowResult, 'basicLevelType') === true) {
          this.levelType = nowResult.basicLevelType;
        }
        */
      }

      const parentCategoryId = parseInt(this.categoryId, 10);
      if (parentCategoryId !== NaN) {
        this.getSubjectListByCategoryId(parentCategoryId);
      }
    });
  },
  data() {
    return {
      isLoading: false,
      levelInfo: {},
      yearInfo: {},
      levelTypeList: {},
      yearList: {},
      teacherList: {},
      year: null,
      levelType: null,
      teacherId: null,
      subjectCategoryId: NaN,
      subjectList: [],
      lectureInfo: {},
    };
  },
  methods: {
    setYear(year) {
      this.year = year;
      this.getLectureListByCategoryId(this.subjectCategoryId);
    },
    setLevelType(levelType) {
      this.levelType = levelType;
      this.getLectureListByCategoryId(this.subjectCategoryId);
    },
    setTeacher() {
      this.getLectureListByCategoryId(this.subjectCategoryId);
    },
    changeSubject(categoryId) {
      this.year = null;
      this.levelType = null;
      this.getLectureListByCategoryId(categoryId);
    },
    getSubjectListByCategoryId(categoryId) {
      this.isLoading = true;
      Axios.get(`/gong/lecture/lecture_ajax/ax_get_SubjectList/${categoryId}`).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result') === true && response.data.result.length > 0) {
          this.subjectList = response.data.result;
          let callSubject = 0;
          if (this.randSubject === true && this.subjectList.length > 2) {
            callSubject = Math.floor((Math.random() * 3));
          }
          this.getLectureListByCategoryId(this.subjectList[callSubject].store_category_id);
        } else {
          this.isLoading = false;
          this.subjectCategoryId = NaN;
          this.subjectList = [];
        }
      });
    },
    getLectureListByCategoryId(subjectCategoryId) {
      this.subjectCategoryId = parseInt(subjectCategoryId, 10);
      this.isLoading = true;
      const callUrl = this.makeCallUrl(`/gong/lecture/lecture_ajax/ax_get_LectureListByCategoryId/${this.subjectCategoryId}`);

      Axios.get(callUrl).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result') === true) {
          const nowResult = response.data.result;
          this.lectureInfo = {};
          if (Object.prototype.hasOwnProperty.call(nowResult.teacherLectureList, 'length') === true && nowResult.teacherLectureList.length > 0) {
            this.lectureInfo = nowResult;
            if (Object.prototype.hasOwnProperty.call(this.teacherList, subjectCategoryId) !== true) {
              this.teacherList[subjectCategoryId] = nowResult.teacherList;
              this.levelTypeList[subjectCategoryId] = nowResult.levelTypeList;
              this.yearList[subjectCategoryId] = nowResult.yearList;
            }
            document.getElementById('teacherList').value = '';
          }
        } else {
          this.lectureInfo = {};
        }

        this.isLoading = false;
      });
    },
    makeCallUrl(baseUrl) {
      let callUrl = baseUrl;
      const addParams = [];

      if (this.isMembershipLectures === true) {
        addParams.push('isPremiumLectures=Y');
      }

      if (this.year !== null && this.year.length > 1) {
        addParams.push(`year=${this.year}`);
      }

      if (this.levelType !== null && this.levelType.length > 1) {
        addParams.push(`levelType=${this.levelType}`);
      }

      if (this.teacherId !== null && this.teacherId.length > 0) {
        addParams.push(`teacherId=${this.teacherId}`);
      }

      if (addParams.length > 0) {
        const paramsStr = addParams.join('&');
        callUrl += `?${paramsStr}`;
      }

      return callUrl;
    },
  },
  components: {
    Loading,
    'online-lecture-list': OnlineLectureList,
  },
};
</script>



// WEBPACK FOOTER //
// src/Lecture/components/online-lecture-membership.vue